import Link from 'next/link';

interface SolutionBreadcrumbProps {
  solutionName: string;
}

export function SolutionBreadcrumb({ solutionName }: SolutionBreadcrumbProps) {
  return (
    <nav aria-label="breadcrumb" className="mb-6">
      <ol className="flex items-center gap-2 text-sm text-neutral-500">
        <li>
          <Link
            href="/solusi"
            className="hover:text-neutral-700 transition-colors"
          >
            Solusi
          </Link>
        </li>
        <li aria-hidden="true" className="text-neutral-300">/</li>
        <li>
          <span className="text-neutral-700 font-medium" aria-current="page">
            {solutionName}
          </span>
        </li>
      </ol>
    </nav>
  );
}
